import React from "react";
import { ToggleSwitch } from "flowbite-react";
import tenkenTheme from "../../../configs/themes/tenkenTheme";
import CustomSpan from "../../CustomSpan";

const Toggle = ({ checked, onClick, name, idx, row }) => {
  return (
    <div className="flex items-center w-full">
      <CustomSpan className="text-tenken-gray-900 mr-2 whitespace-nowrap cursor-pointer"
                  text='無効' onClick={() => onClick(name, false, row, idx)} />
      <ToggleSwitch theme={tenkenTheme}
                    color="primary"
                    checked={checked}
                    onChange={() => onClick(name, !checked, row, idx)} />
      <CustomSpan className="text-tenken-gray-900 ml-2 whitespace-nowrap cursor-pointer"
                  text='有効' onClick={() => onClick(name, true, row, idx)} />
    </div>
  );
};

export default Toggle;
